import React, { Component, useState, useEffect, useRef, useCallback } from "react";
import { RelatedContent, GetSeasons } from "../../Model/Content"; //Include Home
import { isMobile } from "react-device-detect";
import VideoPlayerHLS from "../../components/vidjs/mainPlayer";
import VideoPlayer from "react-awesome-player";
import {
  Addtowatchlistaction,
  Checkuserwatchlist,
  userprofile,
} from "../../Model/Users";
import videojs from "video.js";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import videojsqualityselector from "videojs-hls-quality-selector";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Watchtrailerdetails } from "../../components/vidjs/mainPlayer";
import { RWebShare } from "react-web-share";
import Hover from "../OnHoverDetails/Hover";
import Notifcationdesk from "../../components/Notifcationdesk/Notifcationdesk";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import Search from "../search/Search";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EffectCube } from "swiper";
import $ from "jquery";
import Header from "../common/Header";
import { Genrelist } from "../../Model/Content";
import BarLoader from "react-spinners/BarLoader";
import { Metadata } from "../Metadata/Metadata";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import {
  SVGIcons,
  ImgIcons,
  Imgbanner,
  VirsionCheck,
  Getimg,
  playstatus,
  playtracking,
} from "../../Helpers/Common";
var ImageData = "";
var SVGIcon = "";
var Imgbanners = "";
Imgbanner().then((result) => (Imgbanners = result));
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

var options = {};

function onVideoPlay(player) { }
function onPlayerReady(player) {
  var player = videojs("my-player");
  var options = {};

  var player = videojs("my-player", options, function onPlayerReady() {
    videojs.log("Your player is ready!");

    this.play();

    this.on("ended", function () {
      videojs.log("Awww...over so soon?!");
    });
  });

  var videojs = require("video.js");

  require("videojs-hls-quality-selector");

  var player = videojs("my-video");

  player.hlsQualitySelector({
    displayCurrentQuality: true,
  });

  return player;
}

export function MainDetails(props) {
  const [Addtowatchlist, setAddtowatchlist] = useState(false);
  const [watchtrailer, setwatchtrailer] = useState(false);
  const [userData, setUserData] = useState(false);
  const [SearchClick, setSearchClick] = useState(false);
  const [my_swiper, set_my_swiper] = useState({});
  const [docubytes1, setdocubytes1] = useState({});
  const [docubytes2, setdocubytes2] = useState({});
  const [docubytes3, setdocubytes3] = useState({});
  const [Baysdata, setBaysdata] = useState({});
  const [modalIsOpen, setIsOpen] = useState(false);
  const [vidRefid, setvidRefid] = useState(false);
  const [isLive, setisLive] = useState(true);
  const [silverDIcon, setsilverDIcon] = useState("");
  const [goldenDIcon, setgoldenDIcon] = useState("");
  const [goldenDOriginalIcon, setgoldenDOriginalIcon] = useState("");
  var player = {};
  const playerRef = React.useRef();
  const [SeasonData, setSeasonData] = useState({});
  const navigate = useNavigate();
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [handleTimeout]);

  var contentdata = props.contentdata;
  var RelatedContentdata = props.RelatedContentdata;

  useEffect(() => {
    VirsionCheck().then((vcheckres) => {
      setisLive(JSON.parse(vcheckres.data).data.is_live_tv);
      setsilverDIcon(JSON.parse(vcheckres.data).data["silver-dweb"]);
      setgoldenDOriginalIcon(JSON.parse(vcheckres.data).data["d_original"]);
      setgoldenDIcon(JSON.parse(vcheckres.data).data["golden-dweb"]);
    });
    let data = {
      seesionID: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    }
    userprofile(data).then((userDatares) => {
      if (JSON.parse(userDatares.data.message).success == false) {
        sessionStorage.setItem("refferalUrl", window.location.pathname);
      }
      // if (userDatares.data.message == "session_expired") {
      // navigate("/login");
      // } else {
      var videoURL = contentdata;
      if (videoURL.content.content_type == "EPISODE") {
        var Postdata = {
          content_id: videoURL.show_details.ID,
          session_id: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        };
      } else {
        var Postdata = {
          content_id: videoURL.content.ID,
          session_id: localStorage.getItem("session_id"),
          userID: localStorage.getItem("userID")
        };
      }

      Checkuserwatchlist(Postdata).then((res) => {
        var Response = JSON.parse(res.data);
        var userdata = userDatares.data.message;

        Genrelist().then((GenreData) => {
          if (GenreData.data) {
            userdata = JSON.parse(userdata);

            if (Response.iswatched == true) {
              setAddtowatchlist(true);
            }
            setUserData({
              userData: userdata.user_data,
            });
            var videoURL = contentdata;
            if (videoURL.show_details) {
              var CurrentSeason_id = videoURL.content.parent;
              var PostReq = {
                season_id: CurrentSeason_id,
              };
              GetSeasons(PostReq).then((res) => {
                var SeasonResponse = JSON.parse(res.data.message);
                setBaysdata(GenreData.data.message.Genres);
                setSeasonData(SeasonResponse);
              });
            } else {
              setBaysdata(GenreData.data.message.Genres);
            }
          }
        });
      });
      // }
    });
  }, [docubytes1, docubytes2, docubytes3, my_swiper, vidRefid]);

  function WatchtrailerAction() {
    setwatchtrailer(true);
  }

  function closePlayer() {
    setwatchtrailer(false);
  }

  const search = () => {
    setSearchClick({
      SearchClick: true,
    });
  };

  //Get Data of Current Season.
  function addtowatchlist() {
    var videoURL = contentdata;

    if (Addtowatchlist == true) {
      //Remove from watchlist

      setAddtowatchlist(false);
      var data = {
        content_id: [videoURL.content.ID],
        action: "delete",
      };
    } else {
      //Add To watchlist
      var data = {
        content_id: [videoURL.content.ID],
        action: "add",
      };
      setAddtowatchlist(true);
    }

    Addtowatchlistaction(data).then((Response) => {
      if (Addtowatchlist == true) {
        setAddtowatchlist(false);
        toast("Removed from Watchlist", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message-details",
        });
      } else {
        setAddtowatchlist(true);
        toast("Added to Watchlist", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message-details",
        });
      }
    });
  }

  function getswiper(activeIndex, snapIndex, previousIndex, realIndex) {
    var videoURL = contentdata;

    var ActiveVid;
    var PreVid;
    var videoplayURL;
    if (activeIndex > previousIndex) {
      if (activeIndex == 0) {
        my_swiper.slideTo(0);
        my_swiper.update();

        ActiveVid = docubytes1;
        // videoplayURL = isMobile ? videoURL.content.preview_url1_vertical : videoURL.content.preview_url1;
        if (isMobile) {
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url1_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url1_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url1;
          } else {
            videoplayURL = videoURL.show_details.preview_url1;
          }
        }
        PreVid = docubytes2;
        if (PreVid) {
          playtracking(
            "DOCUBYTE",
            PreVid.currentTime,
            videoURL.content.ID,
            videoURL.content.title
          );
          PreVid.pause();
          //PreVid.currentTime = 0;
        }
      } else if (activeIndex == 1) {
        my_swiper.slideTo(1);
        my_swiper.update();

        ActiveVid = docubytes2;
        PreVid = docubytes1;
        // videoplayURL = isMobile ? videoURL.content.preview_url2_vertical : videoURL.content.preview_url2;
        if (isMobile) {
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url2_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url2_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url2;
          } else {
            videoplayURL = videoURL.show_details.preview_url2;
          }
        }
        if (PreVid) {
          playtracking(
            "DOCUBYTE",
            PreVid.currentTime,
            videoURL.content.ID,
            videoURL.content.title
          );
          PreVid.pause();

          PreVid.currentTime = 0;
        }
      } else if (activeIndex == 2) {
        my_swiper.slideTo(2);
        my_swiper.update();

        // videoplayURL = isMobile ? videoURL.content.preview_url3_vertical : videoURL.content.preview_url3;
        if (isMobile) {
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url3_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url3_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL?.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url3;
          } else {
            videoplayURL = videoURL?.show_details.preview_url3;
          }
        }
        ActiveVid = docubytes3;
        PreVid = docubytes2;
        if (PreVid) {
          playtracking(
            "DOCUBYTE",
            PreVid.currentTime,
            videoURL?.content.ID,
            videoURL?.content.title
          );
          PreVid.pause();
          PreVid.currentTime = 0;
        }
      }
    } else {
      if (activeIndex == 0) {
        my_swiper.slideTo(0);
        my_swiper.update();

        ActiveVid = docubytes1;
        // videoplayURL = isMobile ? videoURL.content.preview_url1_vertical : videoURL.content.preview_url1;
        if (isMobile) {
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url1_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url1_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url1;
          } else {
            videoplayURL = videoURL.show_details.preview_url1;
          }
        }
        PreVid = docubytes2;
        if (PreVid) {
          playtracking(
            "DOCUBYTE",
            PreVid.currentTime,
            videoURL.content.ID,
            videoURL.content.title
          );
          PreVid.pause();
          PreVid.currentTime = 0;
        }
      } else if (activeIndex == 1) {
        my_swiper.slideTo(1);
        my_swiper.update();

        ActiveVid = docubytes2;
        PreVid = docubytes3;
        // videoplayURL = isMobile ? videoURL.content.preview_url2_vertical : videoURL.content.preview_url2;
        if (isMobile) {
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url2_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url2_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url2;
          } else {
            videoplayURL = videoURL.show_details.preview_url2;
          }
        }
        if (PreVid) {
          playtracking(
            "DOCUBYTE",
            PreVid.currentTime,
            videoURL.content.ID,
            videoURL.content.title
          );
          PreVid.pause();
          PreVid.currentTime = 0;
        }
      } else if (activeIndex == 2) {
        my_swiper.slideTo(2);
        my_swiper.update();

        // videoplayURL = isMobile ? videoURL.content.preview_url3_vertical : videoURL.content.preview_url3;
        if (isMobile) {
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url3_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url3_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url3;
          } else {
            videoplayURL = videoURL.show_details.preview_url3;
          }
        }
        ActiveVid = docubytes3;
        PreVid = docubytes2;
        if (PreVid) {
          playtracking(
            "DOCUBYTE",
            PreVid.currentTime,
            videoURL.content.ID,
            videoURL.content.title
          );

          PreVid.pause();
          PreVid.currentTime = 0;
        }
      }
    }

    var videoJsOptions = {
      html5: {
        hls: {
          overrideNative: false,
        },
      },
      hls: {
        withCredentials: true,
      },
      autoplay: true,
      kind: "captions",
      preload: "auto",
      height: "auto",
      width: "100%",
      aspectRatio: "20:10",
      nativeControlsForTouch: false, //nativeControlsForTouch for player js
      disablePictureInPicture: false,
      controls: false,
      sources: [
        {
          src: videoplayURL,
          type: "application/x-mpegURL",
        },
      ],
    };

    var p = videojs(ActiveVid, videoJsOptions);

    p.on("timeupdate", function () {
      var percentage = (p.currentTime() / p.duration()) * 100;
      $("#custom-seekbar span").css("width", percentage + "%");
    });

    if (p) {
      p.play();
    } else {
      p.play();
    }
  }

  function openModal(vidid) {
    var videoURL = contentdata;
    setvidRefid(vidid);
    setIsOpen(true);
    setTimeout(() => {
      my_swiper.slideTo(vidid - 1);
      my_swiper.update();
    }, 300);

    var elementExists = document.getElementById("docubytes-" + vidid);
    if (elementExists != null) {
      /*---------------*/

      var videoplayURL;
      if (vidid == 1) {
        if (isMobile) {
          // videoplayURL = videoURL.content.preview_url1_vertical
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url1_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url1_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url1
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url1;
          } else {
            videoplayURL = videoURL.show_details.preview_url1;
          }
        }
      } else if (vidid == 2) {
        if (isMobile) {
          // videoplayURL = videoURL.content.preview_url2_vertical
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url2_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url2_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url2
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url2;
          } else {
            videoplayURL = videoURL.show_details.preview_url2;
          }
        }
      } else if (vidid == 3) {
        if (isMobile) {
          // videoplayURL = videoURL.content.preview_url3_vertical
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url3_vertical;
          } else {
            videoplayURL = videoURL.show_details.preview_url3_vertical;
          }
        } else {
          // videoplayURL = videoURL.content.preview_url3
          if (videoURL.content.content_type == "VIDEO") {
            videoplayURL = videoURL.content.preview_url3;
          } else {
            videoplayURL = videoURL.show_details.preview_url3;
          }
        }
      }

      var videoJsOptions = {
        html5: {
          hls: {
            overrideNative: false,
          },
        },
        hls: {
          withCredentials: true,
        },
        autoplay: true,
        kind: "captions",
        preload: "auto",
        height: "auto",
        width: "100%",
        nativeControlsForTouch: false, //nativeControlsForTouch for player js
        disablePictureInPicture: false,
        controls: false,
        sources: [
          {
            src: videoplayURL,
            type: "application/x-mpegURL",
            // type:"application/vnd.apple.mpegurl"
            // withCredentials: false,
          },
        ],
      };

      var p = videojs("docubytes-" + vidid, videoJsOptions);
      p.on("timeupdate", function () {
        var percentage = (p.currentTime() / p.duration()) * 100;
        $("#custom-seekbar span").css("width", percentage + "%");
      });
      if (p) {
        p.play();
      } else {
        p.play();
      }
    } else {
    }
  }

  function closeModal() {
    if (docubytes1) {
      var p = videojs("docubytes-1");

      playtracking(
        "DOCUBYTE",
        docubytes1.currentTime,
        videoURL.content.ID,
        videoURL.content.title
      );
      docubytes1.pause();
      p.pause();

      docubytes1.currentTime = 0;
    }
    if (docubytes2) {
      var p = videojs("docubytes-2");

      playtracking(
        "DOCUBYTE",
        docubytes2.currentTime,
        videoURL.content.ID,
        videoURL.content.title
      );
      docubytes2.pause();
      p.pause();

      docubytes2.currentTime = 0;
    }
    if (docubytes3) {
      var p = videojs("docubytes-3");

      playtracking(
        "DOCUBYTE",
        docubytes3.currentTime,
        videoURL.content.ID,
        videoURL.content.title
      );
      docubytes3.pause();
      p.pause();
      docubytes3.currentTime = 0;
    }
    setIsOpen(false);
  }

  function GetSeasonEpisode(CurrentSeason_id) {
    var PostReq = {
      season_id: CurrentSeason_id,
    };
    GetSeasons(PostReq).then((res) => {
      var SeasonResponse = JSON.parse(res.data.message);
      setSeasonData(SeasonResponse);
    });
  }

  if (contentdata && userData && Baysdata.length > 0) {
    var videoURL = contentdata;

    if (videoURL.statusCode == "403") {
      return <p>No content found</p>;
    }
    if (videoURL.content.content_type == "SHOW" || videoURL.content.content_type == "VIDEO") {
      var content = videoURL.content;
    } else {
      var content = videoURL.show_details;
    }

    if (content.content_type && content.content_type == "VIDEO") {
      var Content_type = "Films";
    } else {
      var Content_type = "Series";
    }
    var Tag;
    var awards;
    var Showprogressbar;
    var Percentage;
    var premium;
    var original;
    var video_url_4k;
    var DataURL = content.promo_url_limelight;
    var Duration = Math.floor(content.duration / 60);
    var keywords;
    if (content.premium && content.premium == true && !content.original_tag) {
      premium = (
        <img
          src={silverDIcon}
          style={{
            width: "1.7rem",
            marginRight: "3px",
            marginBottom: "-12px",
          }}
        />
      );
    } else if (content.premium == true && content.original_tag) {
      original = (
        <img
          src={goldenDOriginalIcon}
          style={{
            width: "90px",
            marginRight: "5px",
            marginBottom: "-5px",
          }}
        />
      );
    }
    if (content.awards) {
      var awards = (
        <>
          <img src={SVGIcon["wincup.svg"]} />
          <span className="dot" />
        </>
      );
    }
    if (content.video_4k) {
      video_url_4k = (
        <>
          <div className="nBay1 fBay1">{content.video_4k}</div>
        </>
      );
    } else {
      video_url_4k = (
        <>
          <div className="nBay1 fBay1">{content.video_hd}</div>
        </>
      );
    }

    if (content.keywords) {
      keywords = content.keywords.split(",")[0];
      // keywords = keywords[0];
    }

    if (content.user_duration != 0) {
      Percentage = (content.user_duration / content.duration) * 100;
      var timeremaining = content.duration - content.user_duration;

      Showprogressbar = (
        <>
          <section className="mb-0">
            <div className="temp43">
              {/* {content.content_descriptors.length > 1 ? (
                <div className="bay-title-2">
                  {content.content_descriptors.map((data, index) => {
                    return data + " ";
                  })}
                </div>
              ) : null} */}
              <div className="progress">
                <div
                  className="progress-bar"
                  style={{ width: +Percentage + "%" }}
                />
              </div>
              <div className="bay-title temp43-text">
                {Math.floor(timeremaining / 60)} Mins Left
              </div>
            </div>
          </section>
        </>
      );
    }

    if (setSearchClick === true) {
      return (
        <Search
          functions={this}
          closefrom="true"
          goldenIcon={goldenDIcon}
          silverIcon={silverDIcon}
        />
      );
    }
    if (content.parent) {
      var Watchtrailerdata = videoURL.show_details;
    } else {
      var Watchtrailerdata = content;
    }
    var Today = new Date();
    var Releasing_Date = new Date(content.publish_start_date).getTime();
    Today = new Date(Today).getTime();
    if (Releasing_Date > Today) {
      //releasing soon
      var ShowReleasing = true;
    } else {
      var ShowReleasing = false;
    }
    return (
      <>
        <Metadata page={content.title} contentdetails={content} />
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.3 }}
          key="1"
        >
          {watchtrailer ? (
            <Watchtrailerdetails
              Contentdata={Watchtrailerdata}
              functionclose={closePlayer}
            />
          ) : null}
          <div className="dD-none">
            <div className="mainNav">
              {userData.userData ? (
                <Link to="/">
                  <div className="docubayBack white">
                    <img src={SVGIcon["back.svg"]} alt="DocuBay Logo" />{" "}
                    {Content_type}
                  </div>
                </Link>
              ) : (
                <Header
                  userprofile={userData.userData}
                  bayData={Baysdata}
                  page={"details"}
                  classdata={""}
                />
              )}
              {/* <Link to="/">
                <div className="docubayBack white">
                  <img src={SVGIcon["back.svg"]} alt="DocuBay Logo" />{" "}
                  {Content_type}
                </div>
              </Link> */}
            </div>
          </div>

          <main className="dD-none">
            {props.showmodel ? (
              <div className="temp79">
                <div className="temp79-area-modal">
                  <div className="temp79-item ">
                    <img
                      src={SVGIcon["lock.svg"]}
                      alt="Lock"
                      className="lock-img"
                    />
                    <h5>Become a member to continue watching </h5>
                    <div className="c-watching">
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        className="btn-red"
                      >
                        <Link to="/become-a-member"> Continue </Link>
                      </button>
                    </div>
                    <p>Download our App on</p>
                    <div className="temp79-img">
                      {" "}
                      <a href="https://itunes.apple.com/in/app/epic-on/id1458102898?mt=8">
                        {" "}
                        <img src={ImageData["app-store.png"]} alt="App Store" />
                      </a>{" "}
                      <a href="https://play.google.com/store/apps/details?id=com.epic.docubay">
                        {" "}
                        <img
                          src={ImageData["google-play-badge.png"]}
                          alt="google-play"
                        />{" "}
                      </a>{" "}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <section className="mb-0">
              <div className="homeBanner">
                <div className="banner-overlay detailspage" />
                <div className="innerBanner">
                  <div className="video-thumb-wrapper " img-preview="">
                    <picture>
                      <source
                        srcSet={content.thumbnail_image1?.medium}
                        media="(min-width: 700px)"
                      />
                      <img
                        src={content.thumbnail_image2?.medium}
                        // src={content.mobile_square_banner_cdn?.original}
                        alt="Sign up"
                      />
                    </picture>
                    {/*<VideoPlayerHLS
                        data={DataURL}
                        subtitles={{ subtitles }}
                        post={content.thumbnail_image2}
                      />*/}
                  </div>
                  {/* <div className="play-btn">
                    <Link to={"/playcontent/" + content.slug}>
                      <img
                        src={SVGIcon["play.svg"]}
                        alt="DocuBay"

                      />
                    </Link>
                  </div> */}
                  {ShowReleasing ? (
                    <div className="release-soon">
                      <div className="release-soon-content">
                        <img
                          src={ImageData["lockIcon.png"]}
                          alt="App Store"
                          className="release-soon-icon"
                        />
                        <h4>Releasing Soon... </h4>
                      </div>
                    </div>
                  ) : (
                    <>
                      {userData.userData ? (
                        <div className="play-btn">
                          <Link to={"/playcontent/" + content.slug}>
                            <img src={SVGIcon["play.svg"]} alt="DocuBay" />
                          </Link>
                        </div>
                      ) : null}
                    </>
                  )}
                </div>
              </div>
            </section>
            <section className="mb-0">
              <div className="temp38">
                <div className="temp38Inner">
                  <div className="temp38-head">
                    {/* <img
                      src={content.mobile_title_banner_cdn?.original}
                      alt="Title img"  style={{height: "50px"}}
                    /> */}
                    <p>
                      {content.new ? (
                        <>
                          New
                          <span className="dot" />
                        </>
                      ) : (
                        ""
                      )}
                      {awards}
                      {content.release_date ?
                        <>
                          {content.release_date}
                          {content.content_type == "EPISODE" || content.content_type == "SHOW" ? null :
                            <span className="dot" />
                          }
                        </>
                        : null}
                      {content.content_type == "EPISODE" || content.content_type == "SHOW" ? null :
                        <>
                          {Duration} Mins
                        </>
                      }
                      &nbsp;
                      {!content.premium && !content.original_tag ? (
                        <>
                          Free
                        </>
                      ) : null}
                      {video_url_4k}
                    </p>
                    <h2>{content.title}</h2>
                    <div className="temp38-headInn">
                      <div className="temp38-premium">
                        {premium}
                        {original}
                      </div>
                      <div className="fBay1 fBay2 ">
                        {content.content_category} {content.age_restriction}
                      </div>
                      {content.genres_assign.map((data, index) => {
                        if (index < 1) {
                          return (
                            <div className="fBay" key={index}>
                              {data.name}
                            </div>
                          );
                        }
                      })}
                      <div className="fBay">{keywords}</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {userData.userData ? Showprogressbar : null}
            <section className="mb-0">
              <div className="temp41">
                {userData.userData ?
                  <>
                    <div className="temp41-head">
                      <h3>
                        Docu<span className="red">Bytes</span>
                      </h3>
                    </div>
                    <div className="temp41-area">
                      <div className="temp41-area-box">
                        {videoURL.show_details ? (
                          <img
                            src={videoURL.show_details.preview_image_1.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(1);
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={content.preview_image_1.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(1);
                              }
                            }}
                          />
                        )}
                      </div>
                      <div className="temp41-area-box">
                        {" "}
                        {videoURL.show_details ? (
                          <img
                            src={videoURL.show_details.preview_image_2.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(2);
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={content.preview_image_2.small}
                            onClick={() => {
                              if (userData.userData) {
                                openModal(2);
                              }
                            }}
                            alt="DocuBay"
                          />
                        )}
                      </div>
                      <div className="temp41-area-box">
                        {" "}
                        {videoURL.show_details ? (
                          <img
                            src={videoURL.show_details.preview_image_3.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(3);
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={content.preview_image_3.small}
                            onClick={() => {
                              if (userData.userData) {
                                openModal(3);
                              }
                            }}
                            alt="DocuBay"
                          />
                        )}
                      </div>
                    </div>
                  </>
                  : null}
                {/* {userData.userData ? ( */}
                <div className="formField mb-0">
                  <Link to={"/watchtrailer/" + content.slug}>
                    <button
                      type="submit"
                      id="sendEnquiryBtn"
                      className="btn-black btn-gray white"
                      style={{ marginTop: "12px" }}
                      onClick={() => {
                        WatchtrailerAction();
                      }}
                    >
                      Watch Trailer
                    </button>
                  </Link>
                </div>
                {/* ) : null} */}
              </div>
            </section>
            {userData.userData ? (
              <section className="mb-0">
                <div className="temp42">
                  <div className="temp42-share-icons">
                    <div className="temp42-share-box" onClick={addtowatchlist}>
                      {Addtowatchlist ? (
                        <img src={SVGIcon["red-right.svg"]} />
                      ) : (
                        <img src={SVGIcon["wave-right.svg"]} />
                      )}
                      <p>Watchlist</p>
                    </div>
                    {/* <div className="temp42-share-box"> */}
                    {/* <img src={SVGIcon["share-inn.svg"]} alt="Docubay" /> */}
                    {/* <p>Share</p> */}
                    {/* </div> */}
                    <RWebShare
                      data={{
                        url: props.contentdata.content.content_type == "VIDEO" ? "https://share.docubay.com/" + props.contentdata.content.slug : props.contentdata.show_details.content_type == "SHOW" ? "https://share.docubay.com/" + props.contentdata.show_details.slug : null,
                        title: props.contentdata.content.content_type == "VIDEO" ? props.contentdata.content.title : props.contentdata.show_details.content_type == "SHOW" ? props.contentdata.show_details.title : null,
                        // text: contentdata.content.description,
                        // url:
                        //   window.location.href.slice(0, 23) +
                        //   "/" +
                        //   props.data?.slug,
                      }}
                    >
                      <div className="temp42-share-box">
                        <img src={SVGIcon["share-inn.svg"]} alt="DocuBay" />
                        <p>Share</p>
                      </div>
                    </RWebShare>
                    {/*<div className="temp42-share-box">
                    <img src={SVGIcon["downloads-inn.svg"]} alt="Docubay" />
                    <p>Download</p>
                  </div>*/}
                  </div>
                </div>
              </section>
            ) : null}
            <section className="mb-0">
              <div className="temp39">
                <div className="temp39Inn">
                  <div className="temp39-text">
                    <div className="more">
                      {videoURL.show_details ? SeasonData.season_data?.description : content?.description}
                    </div>
                    <h6>
                      <div className="award-title1">Director:</div>
                      {content.castncrew.director}
                    </h6>
                    {content.award_winning ? (
                      <h6>
                        <div className="award-title">Awards:</div>
                        {content.award_winning}
                      </h6>
                    ) : null}
                  </div>
                </div>
              </div>
            </section>
            {videoURL.show_details ? (
              <section className="mb-0">
                <div className="temp44">
                  <div className="temp44-head">Episodes</div>
                  <div className="temp44-tabs">
                    <ul id="temp44-tabs-nav">
                      {videoURL.total_seasons.map((Data, index) => {
                        if (SeasonData.season_data) {
                          if (SeasonData.season_data.ID == Data.ID) {
                            return (
                              <li className="active">
                                <a
                                  onClick={() => GetSeasonEpisode(Data.ID)}
                                  className="active"
                                >
                                  Season {index + 1}
                                </a>
                              </li>
                            );
                          } else {
                            return (
                              <li>
                                <a
                                  onClick={() => GetSeasonEpisode(Data.ID)}
                                  className="active"
                                >
                                  Season {index + 1}
                                </a>
                              </li>
                            );
                          }
                        }
                      })}
                    </ul>{" "}
                    {/* END tabs-nav */}
                    <div id="temp44-tabs-content">
                      {/*Details here */}

                      <div
                        id="temp44-tab1"
                        className="temp44-tab-content"
                        style={{}}
                      >
                        {SeasonData
                          ? SeasonData.season_data.episodes.map(
                            (EpisodesData, index) => {
                              return (
                                <div className="temp45-inn" key={index}>
                                  <div className="temp45-inn-area">
                                    {/* <div className="temp45-left">
                                      <img
                                        src={SVGIcon["play-2.svg"]}
                                        className="temp45-btn"
                                      />
                                      <a href={"/details/" + EpisodesData.slug}>
                                        <img
                                          src={
                                            EpisodesData.thumbnail_image1.medium
                                          }
                                          alt="DocuBay"
                                        />
                                      </a>
                                      <div className="progress">
                                        <div className="progress-bar" />
                                      </div>
                                    </div> */}
                                    {ShowReleasing ? (
                                      <div className="temp45-left">
                                        <div className="release-soon-content1">
                                          <img
                                            src={ImageData["lockIcon.png"]}
                                            alt="App Store"
                                          />
                                          <h4>Releasing Soon... </h4>
                                        </div>
                                        <div>
                                          <img
                                            src={
                                              EpisodesData.thumbnail_image1
                                                .small
                                            }
                                            alt="DocuBay"
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="temp45-left">
                                        {userData.userData ? (
                                          <a
                                            href={
                                              "/playcontent/" +
                                              EpisodesData.slug
                                            }
                                          >
                                            <img
                                              src={SVGIcon["play-2.svg"]}
                                              className="temp45-btn"
                                            />
                                          </a>
                                        ) : null}

                                        <a
                                          href={
                                            userData.userData
                                              ? "/playcontent/" +
                                              EpisodesData.slug
                                              : null
                                          }
                                        >
                                          <img
                                            src={
                                              EpisodesData.thumbnail_image1
                                                ?.small
                                            }
                                            alt="DocuBay"
                                          />
                                        </a>
                                      </div>
                                    )}

                                    <div className="temp45-right">
                                      <h5>{EpisodesData.title} </h5>
                                      <h6>
                                        {EpisodesData.duration / 60} Mins
                                      </h6>
                                    </div>
                                  </div>
                                  <div className="temp45-bot">
                                    <h6>{EpisodesData.description}</h6>
                                  </div>
                                </div>
                              );
                            }
                          )
                          : null}
                      </div>
                    </div>{" "}
                    {/* END tabs-content */}
                  </div>{" "}
                  {/* END tabs */}
                </div>
              </section>
            ) : null}
            <section className="mb-0">
              <div className="temp40">
                {/* {showShimmer ? (
                  <div className="line linehead" />
                ) : (
                  <>    </>
                  )} */}
                <div className="head">
                  <h3>More like this</h3>
                </div>

                <div className="temp40-area">
                  {RelatedContentdata.success == true ? (
                    <Swiper
                      slidesPerView={2.4}
                      spaceBetween={16}
                      freeMode={true}
                      loop={false}
                      loopFillGroupWithBlank={true}
                      centeredSlides={false}
                      breakpoints={{
                        700: {
                          slidesPerView: 4.7,
                        },
                      }}
                      modules={[FreeMode, Pagination]}
                      className="temp14-slider temp40-area"
                    >
                      {RelatedContentdata.contents.map((data, index) => {
                        var keyword = data.keywords?.split[0];
                        // keyword = keyword[0];
                        var premium = "";
                        // var Bannerimg;
                        // Getimg(data, "V").then((result) => (Bannerimg = result));

                        if (data.premium && !data.original_tag) {
                          var premium = (
                            <img
                              src={silverDIcon}
                              style={{
                                width: "1.3rem",
                                marginRight: "3px",
                                marginBottom: "2px",
                              }}
                            />
                          );
                        }
                        if (data.original_tag && data.premium) {
                          var original = (
                            <img
                              src={goldenDIcon}
                              style={{
                                width: "1.3rem",
                                marginRight: "3px",
                                marginBottom: "2px",
                              }}
                            />
                          );
                        }
                        return (
                          <SwiperSlide className="temp40-item" key={index}>
                            {/* {showShimmer ? (
                              <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                            ) : (
                              <>
                                   </>
                            )} */}
                            <div className="temp40-itemColor">
                              <a href={"/" + data.slug}>
                                <img
                                  // src={Bannerimg}
                                  src={data.vertical_banner.small}
                                  alt="DocuBay"
                                />
                              </a>
                            </div>
                            <div className="bay-title">{keyword}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </SwiperSlide>
                        );
                      })}
                      <SwiperSlide></SwiperSlide>
                    </Swiper>
                  ) : null}
                </div>
              </div>
            </section>
          </main>

          {/* desktop section */}
          <div className={modalIsOpen ? "temp79" : "temp79 displaynon"}>
            <div className="temp79-area-docubytes">
              <div className="temp79-item ">
                {/* <a> */}
                <img
                  src={ImageData["icons8-close-50.png"]}
                  className="close-modal-docubytes"
                  onClick={() => {
                    closeModal();
                  }}
                />
                {/* </a> */}
                <div id="custom-seekbar">
                  <span></span>
                </div>
                <Swiper
                  effect={"cube"}
                  grabCursor={true}
                  cubeEffect={{
                    shadow: true,
                    slideShadows: true,
                    shadowOffset: 20,
                    shadowScale: 0.94,
                  }}
                  onSlideChange={(swiperCore) => {
                    const { activeIndex, snapIndex, previousIndex, realIndex } =
                      swiperCore;

                    getswiper(activeIndex, snapIndex, previousIndex, realIndex);
                  }}
                  onInit={(ev) => {
                    set_my_swiper(ev);
                  }}
                  initialSlide={modalIsOpen ? vidRefid : 0}
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  pagination={true}
                  modules={[EffectCube, Pagination, Navigation]}
                  className="docubytes-swiper-ss"
                >
                  <div className="side-overlay-L dD-block"></div>
                  <button className="slick-prev slick-arrow" type="button" />
                  <SwiperSlide>
                    <video
                      id="docubytes-1"
                      poster={
                        videoURL.show_details
                          ? videoURL.show_details.preview_image_1.small
                          : content.preview_image_1.small
                      }
                      className="onhove"
                      ref={(videl1) => setdocubytes1(videl1)}
                      playsInline={true}
                    />
                    <div className="title-img-docubytes">
                      <img src={videoURL.show_details ? videoURL.show_details.title_image_newui?.original : content.title_image_newui?.original} />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <video
                      id="docubytes-2"
                      poster={
                        videoURL.show_details
                          ? videoURL.show_details.preview_image_2.small
                          : content.preview_image_2.small
                      }
                      className="onhove"
                      ref={(videl2) => setdocubytes2(videl2)}
                      playsInline={true}
                    />
                    <div className="title-img-docubytes">
                      <img
                        src={
                          videoURL.show_details
                            ? videoURL.show_details.title_image_newui?.original
                            : content.title_image_newui?.original
                        }
                      />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <video
                      id="docubytes-3"
                      poster={
                        videoURL.show_details
                          ? videoURL.show_details.preview_image_3.small
                          : content.preview_image_3.small
                      }
                      className="onhovr"
                      ref={(videl3) => setdocubytes3(videl3)}
                      playsInline={true}
                    />
                    <div className="title-img-docubytes">
                      <img
                        src={
                          videoURL.show_details
                            ? videoURL.show_details.title_image_newui?.original
                            : content.title_image_newui?.original
                        }
                      />
                    </div>
                  </SwiperSlide>
                  <div className="side-overlay-R dD-block"></div>
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </div>
          <main className="dD-block d">
            <Header
              userprofile={userData.userData}
              bayData={Baysdata}
              page={"details"}
              classdata={""}
            />
            {props.showmodel ? (
              <div className="temp79">
                <div className="temp79-area temp79-area-modal">
                  <div className="temp79-item ">
                    <a
                      onClick={() => {
                        props.Closemodel();
                      }}
                    >
                      <img
                        src={ImageData["close.png"]}
                        className="close-modal-icon Closemodel"
                      />
                    </a>
                    <img
                      src={SVGIcon["lock.svg"]}
                      alt="Lock"
                      className="lock-img"
                    />
                    <h5>Become a member to continue watching </h5>
                    <div className="c-watching">
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        className="btn-red"
                      >
                        <Link to="/become-a-member"> Continue </Link>
                      </button>
                    </div>

                    <p>Download our App on</p>
                    <div className="temp79-img">
                      {" "}
                      <a href="#">
                        {" "}
                        <img src={ImageData["app-store.png"]} alt="App Store" />
                      </a>{" "}
                      <a href="#">
                        {" "}
                        <img
                          src={ImageData["google-play-badge.png"]}
                          alt="google-play"
                        />{" "}
                      </a>{" "}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <section className="mb-0 detail-banner">
              <div className="banner-over-details">
                <div className="content-d1">
                  {content.new ? (
                    <>
                      New
                      <span className="dot" />
                    </>
                  ) : (
                    ""
                  )}
                  {awards}
                  {content.release_date ?
                    <>
                      {content.release_date}
                      {content.content_type == "EPISODE" || content.content_type == "SHOW" ? null :
                        <span className="dot" />
                      }
                    </>
                    : null}
                  {content.content_type == "EPISODE" || content.content_type == "SHOW" ? null :
                    <>
                      <div>{Duration} Mins</div>
                    </>
                  }
                  &nbsp;
                  {!content.premium && !content.original_tag ? (
                    <>
                      Free
                    </>
                  ) : null}
                  {content.video_4k ? (
                    <span className="hd-mainDetails">4K</span>
                  ) : content.video_hd ? (
                    <span className="hd-mainDetails">HD</span>
                  ) : null}
                </div>
                <div className="banner-hover-align">
                  {contentdata?.content?.title_image_newui?.original ? (
                    <img src={contentdata?.content?.title_image_newui?.original} className="banner-logo" alt="Sign up" />
                  ) : (
                    <img src={contentdata.show_details?.title_image_newui?.original}
                      alt="Sign up" className="banner-logo"
                    />
                  )}
                  {/* {Object.keys(contentdata?.content?.title_image_newui).length > 0 ? (
                    <img
                      src={contentdata?.content?.title_image_newui.original}
                      className="banner-logo"
                    />
                  ) : contentdata?.content?.title_image_newui ? (
                    <img
                      src={content.title_image_newui.original}
                      className="banner-logo"
                    />
                  ) : SeasonData.season_data.title_image_newui ? (
                    <img
                      src={SeasonData.season_data.title_image_newui.original}
                      className="banner-logo"
                    />
                  ) : null} */}
                </div>
                <div className="temp38-headInn1">
                  <div className="premium-details">
                    {content.premium && !content.original_tag ? (
                      <img
                        src={silverDIcon}
                        style={{
                          width: "1.7rem",
                          marginRight: "3px",
                          marginBottom: "2px",
                        }}
                      />
                    ) : null}
                    {content.premium == true && content.original_tag ? (
                      <>
                        <div style={{ display: "flex" }}>
                          <img
                            src={goldenDOriginalIcon}
                            style={{
                              width: "9rem",
                              marginRight: "6px",
                              marginBottom: "2px",
                            }}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div className="fBay1 fBay2 ">
                    {content.content_category} {content.age_restriction}
                  </div>
                  {content.genres_assign.map((data, index) => {
                    if (index < 1) {
                      return (
                        <div className="fBay" key={index}>
                          {data.name}
                        </div>
                      );
                    }
                  })}
                  <div className="fBay">{keywords}</div>
                </div>
                <div className="footer-banner-details">
                  <div className="watch-trailer-details">
                    <Link to={"/watchtrailer/" + content.slug}>
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        className="btn-black btn-gray white dd"
                        onClick={() => {
                          WatchtrailerAction();
                        }}
                      >
                        Watch Trailer
                      </button>
                    </Link>
                  </div>
                  {userData.userData ? (
                    <div className="temp42">
                      <div className="temp42-share-icons">
                        <div
                          className="temp42-share-box"
                          onClick={addtowatchlist}
                        >
                          {Addtowatchlist ? (
                            <img src={SVGIcon["red-right.svg"]} />
                          ) : (
                            <img src={SVGIcon["wave-right.svg"]} />
                          )}
                          <p>Watchlist</p>
                        </div>
                        <RWebShare
                          data={{
                            url: props.contentdata.content.content_type == "VIDEO" ? "https://share.docubay.com/" + props.contentdata.content.slug : props.contentdata.show_details.content_type == "SHOW" ? "https://share.docubay.com/" + props.contentdata.show_details.slug : null,
                            title: props.contentdata.content.content_type == "VIDEO" ? props.contentdata.content.title : props.contentdata.show_details.content_type == "SHOW" ? props.contentdata.show_details.title : null,
                            // text: contentdata.content.description,
                            // url:
                            //   window.location.href.slice(0, 23) +
                            //   "/" +
                            //   props.data?.slug,
                          }}
                        >
                          <div className="temp42-share-box">
                            <img src={SVGIcon["share-inn.svg"]} alt="Docubay" />
                            <p>Share</p>
                          </div>
                        </RWebShare>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="detail-banner-content">
                {/* <div className="banner-overlay detailspage" /> */}
                <div className="banner-img-details">
                  <picture>
                    {contentdata?.content?.mxplayer_landscape_banner?.original ? (
                      <img src={contentdata?.content?.mxplayer_landscape_banner?.original} alt="Sign up" />
                    ) : (
                      <img src={contentdata.show_details?.mxplayer_landscape_banner?.original}
                        alt="Sign up"
                      />
                    )}
                  </picture>
                </div>
                {/* </div> */}
                {ShowReleasing == true ? (
                  <div className="release-soon">
                    <div className="release-soon-content" style={{ cursor: "auto" }}>
                      <img src={ImageData["lockIcon.png"]} alt="App Store" />
                      <h4>Releasing Soon... </h4>
                    </div>
                  </div>
                ) : (
                  <>
                    {userData.userData ? (
                      <div>
                        <Link to={"/playcontent/" + content.slug}>
                          <div className="play-btn-details w">
                            <img src={SVGIcon["play.svg"]} alt="DocuBay" />
                          </div>
                        </Link>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </section>

            <section className="mb-0">
              <div className="details-content2">

                {userData.userData ?
                  <div className="left-docubytes">
                    <div className="left-docubytes-head">
                      <h3>
                        Docu<span className="red">Bytes</span>
                      </h3>
                    </div>
                    <div className="left-docubytes-area">
                      <div className="left-docubytes-area-box">
                        {videoURL.show_details ? (
                          <img
                            src={videoURL.show_details.preview_image_1.small}
                            alt="Docubytes"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(1);
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={content.preview_image_1.small}
                            alt="Docubytes"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(1);
                              }
                            }}
                          />
                        )}
                      </div>

                      <div className="left-docubytes-area-box">
                        {" "}
                        {videoURL.show_details ? (
                          <img
                            src={videoURL.show_details.preview_image_2.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(2);
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={content.preview_image_2.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(2);
                              }
                            }}
                          />
                        )}
                      </div>
                      <div className="left-docubytes-area-box">
                        {" "}
                        {videoURL.show_details ? (
                          <img
                            src={videoURL.show_details.preview_image_3.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(3);
                              }
                            }}
                          />
                        ) : (
                          <img
                            src={content.preview_image_3.small}
                            alt="DocuBay"
                            onClick={() => {
                              if (userData.userData) {
                                openModal(3);
                              }
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  : null
                }

                <div className="right-docubytes">
                  <div className="temp39-text">
                    <div className="text-head-about">About</div>
                    <div className="more">
                      {videoURL.show_details
                        ? SeasonData.season_data?.description
                        : content?.description}
                    </div>
                    <h6>
                      <div className="award-title1">Director:</div>
                      {content.castncrew.director}
                    </h6>
                    {content.award_winning ? (
                      <h6>
                        <div className="award-title">Awards:</div>{" "}
                        {content.award_winning}
                      </h6>
                    ) : null}
                  </div>
                </div>
              </div>
            </section>

            {userData.userData ? Showprogressbar : null}

            {videoURL.show_details ? (
              <section className="mb-0">
                <div className="temp44">
                  <div className="temp44-head">Episodes</div>
                  <div className="temp44-tabs">
                    <ul id="temp44-tabs-nav">
                      {videoURL.total_seasons.map((Data, index) => {
                        if (SeasonData.season_data) {
                          if (SeasonData.season_data.ID == Data.ID) {
                            return (
                              <li className="active">
                                <a
                                  onClick={() => GetSeasonEpisode(Data.ID)}
                                  className="active"
                                >
                                  Season {index + 1}
                                </a>
                              </li>
                            );
                          } else {
                            return (
                              <li>
                                <a
                                  onClick={() => GetSeasonEpisode(Data.ID)}
                                  className="active"
                                >
                                  Season {index + 1}
                                </a>
                              </li>
                            );
                          }
                        }
                      })}
                    </ul>{" "}
                    <div id="temp44-tabs-content">
                      <div
                        id="temp44-tab1"
                        className="temp44-tab-content"
                        style={{}}
                      >
                        {SeasonData
                          ? SeasonData.season_data.episodes.map(
                            (EpisodesData, index) => {
                              return (
                                <div className="temp45-inn" key={index}>
                                  <div className="temp45-inn-area">
                                    {ShowReleasing ? (
                                      <div className="temp45-left" style={{ cursor: "auto" }}>
                                        <div className="release-soon-content1">
                                          <img
                                            src={ImageData["lockIcon.png"]}
                                            alt="App Store"
                                          />
                                          <h4>Releasing Soon... </h4>
                                        </div>
                                        <div>
                                          <img
                                            src={
                                              EpisodesData.thumbnail_image1
                                                .small
                                            }
                                            alt="DocuBay"
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="temp45-left">
                                        {userData.userData ? (
                                          <a
                                            href={
                                              "/playcontent/" +
                                              EpisodesData.slug
                                            }
                                          >
                                            <img
                                              src={SVGIcon["play-2.svg"]}
                                              className="temp45-btn"
                                            />
                                          </a>
                                        ) : null}

                                        <a
                                          href={
                                            userData.userData ? "/playcontent/" + EpisodesData.slug : null
                                          }
                                        >
                                          <img
                                            src={
                                              EpisodesData.thumbnail_image1
                                                ?.small
                                            }
                                            alt="DocuBay"
                                          />
                                        </a>
                                      </div>
                                    )}

                                    <div className="temp45-right">
                                      <h4>{EpisodesData.title} </h4>
                                      <h5>
                                        {EpisodesData.duration / 60} Mins
                                      </h5>
                                      <h6>
                                        {/* {EpisodesData.description.substring(
                                          0,
                                          100
                                        )}
                                        ... */}
                                        {EpisodesData.description}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )
                          : null}
                      </div>
                    </div>{" "}
                  </div>{" "}
                </div>
              </section>
            ) : null}
            <section className="mb-0">
              <div className="temp40">
                {/* {showShimmer ? (
                  <div className="linedesk" />
                ) : (
                  <>
                      </>
                )} */}
                <div className="head">
                  <h3>More like this</h3>
                </div>
                <div className="temp40-area">
                  {RelatedContentdata.success == true ? (
                    <Swiper
                      navigation={{
                        prevEl: ".slick-prev",
                        nextEl: ".slick-next",
                      }}
                      slidesPerView={2.4}
                      spaceBetween={16}
                      freeMode={true}
                      loop={false}
                      loopFillGroupWithBlank={true}
                      centeredSlides={false}
                      breakpoints={{
                        650: {
                          slidesPerView: 1,
                        },
                        850: {
                          slidesPerView: 6.3,
                        },
                      }}
                      modules={[FreeMode, Pagination, Navigation]}
                      className="temp14-slider"
                    >
                      <button
                        className="slick-prev slick-arrow"
                        type="button"
                        aria-label="Previous"
                      />
                      {RelatedContentdata.contents.map((data, index) => {
                        var keyword = data.keywords?.split[0];
                        // keyword = keyword[0];
                        var premium = "";
                        // if (data.premium) {
                        //   var premium = <img src={SVGIcon["Premvg.svg"]} />;
                        // }
                        if (data.premium && !data.original_tag) {
                          var premium = (
                            <img
                              src={silverDIcon}
                              style={{
                                width: "1.7rem",
                                marginRight: "3px",
                                marginBottom: "2px",
                              }}
                            />
                          );
                        }
                        if (data.original_tag && data.premium) {
                          var original = (
                            <img
                              src={goldenDIcon}
                              style={{
                                width: "1.7rem",
                                marginRight: "3px",
                                marginBottom: "2px",
                              }}
                            />
                          );
                        }
                        return (
                          <>
                            <SwiperSlide className="temp40-item" key={index}>
                              {/* {showShimmer ? (
                                <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                              ) : (
                                <>
                                    </>
                              )} */}
                              <a href={"/" + data.slug}>
                                <div className="temp40-itemColor">
                                  <img
                                    src={data.vertical_banner.small}
                                    alt="DocuBay"
                                  />
                                </div>
                                <div className="bay-title" style={{ paddingRight: "20px !important" }}>{keyword}</div>
                                <div className="premium-red">
                                  {premium}
                                  {original}
                                </div>
                              </a>
                            </SwiperSlide>
                          </>
                        );
                      })}
                      <SwiperSlide></SwiperSlide>
                      <button
                        className="slick-next slick-arrow"
                        type="button"
                        aria-label="Next"
                      />
                    </Swiper>
                  ) : null}
                </div>
              </div>
            </section>
            {window.innerWidth > 768 ? <Footerdesk /> : null}
          </main>
          {userData.userData ? <Mobilemenu active="1" isLive={isLive} /> : null}
        </motion.div>
      </>
    );
  } else {
    return (
      <div className="loader">
        <BarLoader color="#ff000f" />
      </div>
    );
  }
}
